import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overMap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_select, {
      modelValue: _ctx.selectedUid,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedUid) = $event)),
      filled: "",
      clearable: "",
      "use-input": "",
      "hide-selected": "",
      "hide-dropdown-icon": "",
      "fill-input": "",
      "input-debounce": "300",
      options: _ctx.options,
      style: {"width":"250px"},
      onInput: _ctx.setSelectedDevice,
      onFilter: _ctx.filterFn
    }, {
      "no-option": _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "text-grey" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" No results ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      append: _withCtx(() => [
        _createVNode(_component_q_icon, { name: "search" })
      ]),
      _: 1
    }, 8, ["modelValue", "options", "onInput", "onFilter"])
  ]))
}